/**
 * Product visibility for Crowd Vibe.
 *
 * Hosts always see it after creation. Guests see it only after their own
 * saved preference exists. Draft edits stay local and still use the saved
 * preference for crowd aggregation.
 */

export function canSeeCrowdVibe({ isHost, hasSubmitted }) {
  if (isHost) return true;
  return Boolean(hasSubmitted);
}

export function blocksPartyUntilVibe({ isHost, phase }) {
  if (isHost) return false;
  return phase === 'loading' || phase === 'choose';
}

export function createVibeSession(isHost) {
  return {
    phase: isHost ? 'party' : 'loading',
    saved: null,
    notice: '',
  };
}

export function vibeSessionReducer(state, action) {
  switch (action.type) {
    case 'reset':
      return createVibeSession(Boolean(action.isHost));
    case 'own-loaded': {
      if (action.isHost) {
        return {
          ...state,
          phase: state.phase === 'editing' ? 'editing' : 'party',
          saved: action.preference,
        };
      }
      if (!action.preference) {
        if (state.phase === 'editing' && state.saved) return state;
        return {
          ...state,
          phase: 'choose',
          saved: null,
        };
      }
      if (state.phase === 'editing') {
        return { ...state, saved: action.preference };
      }
      return {
        ...state,
        phase: 'party',
        saved: action.preference,
      };
    }
    case 'edit':
      if (!state.saved) return state;
      return { ...state, phase: 'editing' };
    case 'cancel':
      if (!state.saved) return state;
      return { ...state, phase: 'party' };
    case 'saved':
      return {
        ...state,
        phase: 'party',
        saved: action.preference,
      };
    case 'notice':
      return { ...state, notice: action.notice || '' };
    default:
      return state;
  }
}
